import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Filter } from 'lucide-react';
import { currentRefinements } from 'instantsearch.js/es/widgets';
import styles from './FilterBar.module.scss';

const FilterBar = ({ search, activeCount, onOpenFilters }) => {
  const currentRefinementsRef = useRef(null);
  const widgetsMounted = useRef(false);

  useEffect(() => {
    if (!search || widgetsMounted.current) return;
    widgetsMounted.current = true;

    search.addWidgets([
      currentRefinements({
        container: currentRefinementsRef.current,
        cssClasses: {
          root: styles.currentRefinementsRoot,
          list: styles.currentRefinementsList,
          item: styles.currentRefinementsItem,
          label: styles.currentRefinementsLabel,
          category: styles.currentRefinementsCategory,
          categoryLabel: styles.currentRefinementsCategoryLabel,
          delete: styles.currentRefinementsDelete,
        },
      }),
    ]);
  }, [search]);

  return (
    <div className={styles.filterBar}>
      <div className={styles.filterBarLeft}>
        <button className={styles.filtersBtn} onClick={onOpenFilters}>
          <Filter size={15} />
          <span>Filters</span>
          {activeCount > 0 && (
            <span className={styles.filtersBadge}>{activeCount}</span>
          )}
        </button>

        <div
          ref={currentRefinementsRef}
          className={styles.currentRefinementsWrapper}
        />
      </div>
    </div>
  );
};

FilterBar.propTypes = {
  search: PropTypes.object,
  activeCount: PropTypes.number.isRequired,
  onOpenFilters: PropTypes.func.isRequired,
};

export default FilterBar;
